import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the CustomerRewardGainedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-customer-reward-gained',
  templateUrl: 'customer-reward-gained.html',
})
export class CustomerRewardGainedPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CustomerRewardGainedPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/customer-reward-gained/customer-reward-gained.ts